module.exports = __webpack_public_path__ + "img/playing-icon.4d873c07.svg";